<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Special Prize Pools in Bounty Cases"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        Some weapon cases include a special prize pool with golden reward icon, which contains very rare melee and glove
        skin rewards.
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>